import Image from "next/image"
import { useMediaPredicate } from "react-media-hook"
import { truncateString } from "@/lib/helpers/utils"
import { Person } from "@/common/icons/person"
import Button from "@/common/button/button"
import HeadingLabel from "@/common/partials/heading-label/heading-label"

export default function Byline({ byline }) {
  const sendMail = () => {
    window.location = "mailto:" + byline.email
  }

  let truncatedEmail = byline.email
  const isSmallMobile = useMediaPredicate("(max-width: 320px)")
  const isMobile = useMediaPredicate("(max-width: 640px)")

  if (isSmallMobile) {
    truncatedEmail = truncateString(byline.email, 20)
  } else if (isMobile) {
    truncatedEmail = truncateString(byline.email, 30)
  }

  const avatarClass = byline?.avatar?.url ? "" : "w-full justify-between"

  return (
    <div className="box-content max-w-screen-sm px-4 mx-auto mb-10 md:mb-15 lg:mb-20 sm:px-10 md:max-w-1xl">
      <div className="flex justify-between pt-3 space-x-5 border-t-2 border-solid border-black-100/10 items-top post-byline-wrapper">
        <Avatar avatar={byline?.avatar} />
        <div className={["flex-grow font-sans md:flex", avatarClass].join(" ")}>
          <div className="md:flex-grow text-wrapper">
            <HeadingLabel className="block">{byline.position}</HeadingLabel>
            <span className="block pb-1 font-medium">{byline.name}</span>
            {byline.desc.length > 0 && (
              <span
                className="block pb-2 pr-5 text-sm leading-6 md:text-lg md:leading-7"
                dangerouslySetInnerHTML={{ __html: byline.desc }}></span>
            )}
            {byline.email && (
              <div className="max-w-full">
                <a
                  href={`mailto:${byline.email}`}
                  className="text-sm leading-normal">
                  {truncatedEmail}
                </a>
              </div>
            )}
            <Phone {...{ byline }} />
          </div>

          {byline.email && (
            <div className="mt-4 button-wrapper md:mt-7">
              <Button
                size="small"
                theme="light-lime"
                ariaLabel="Ta kontakt"
                onClick={sendMail}
                className="block no-print">
                Ta kontakt
              </Button>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

const Phone = ({ byline }) => {
  const links = []

  if (byline.phone) {
    links.push(
      <a
        key="phone"
        href={`tel: ${byline.phone}`}
        className="inline-block text-sm leading-normal">
        {byline.phone}
      </a>
    )

    if (byline.altPhone) {
      links.push(
        <span
          key="separator"
          className="inline-block px-1 text-sm leading-normal">
          /
        </span>
      )
    }
  }

  if (byline.altPhone) {
    links.push(
      <a
        key="alt-phone"
        href={`tel: ${byline.altPhone}`}
        className="inline-block text-sm leading-normal">
        {byline.altPhone}
      </a>
    )
  }

  return links
}

const Avatar = ({ avatar }) => {
  if (!avatar)
    return (
      <div className="flex-none">
        <figure className="flex items-center justify-center rounded-full w-icon-xxl h-icon-xxl bg-black-100/10">
          <Person className="w-10 h-10 mb-1 fill-[#CCC]" />
        </figure>
      </div>
    )

  return (
    <div className="flex-none">
      {avatar.url && (
        <figure className="rounded-full aspect-w-1 aspect-h-1 w-icon-xxl h-icon-xxl">
          <Image
            className={`rounded-full object-cover object-center w-full h-full`}
            src={avatar.url}
            sizes="256px"
            alt={avatar.alt}
            layout="fill"
            loading="lazy"
          />
        </figure>
      )}
    </div>
  )
}
